import { getBaseUrl } from '@utils/routing';

const getLogoutUrl = () => `${getBaseUrl()}/auth/logout`;

export { getBaseUrl, getLogoutUrl };
